import { render, staticRenderFns } from "./AddEquipamento.vue?vue&type=template&id=06a28bdc&scoped=true&"
import script from "./AddEquipamento.vue?vue&type=script&lang=js&"
export * from "./AddEquipamento.vue?vue&type=script&lang=js&"
import style0 from "./AddEquipamento.vue?vue&type=style&index=0&id=06a28bdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a28bdc",
  null
  
)

export default component.exports